import { Component, OnInit, } from '@angular/core';
import { AuthService } from '../auth.service';
import { Configuration } from '../conf/app.constants';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'sso-logout',
  templateUrl: 'sso-logout.template.html'
})
export class SsoLogoutComponent implements OnInit {

  constructor(private authService: AuthService, private _configuration: Configuration, private http: HttpClient, private router: Router) {
    // limpiamos la información de la sesion
    // a clase de la que hereden todos los componentes de login !!!!
    authService.cleanSessionInfo();
  }

  /**
   * Se hace login invocando a la URL del servidor SSO.
   */
  ngOnInit(): void {
    let ssoLogoutURL = this._configuration.URL_BASE + 'sso/logout';
    this.http.get<any>(ssoLogoutURL).pipe(
      finalize(() => {
        this.router.navigate(['logout-msg']);
      })).subscribe();
  }

}
